export { default } from './ResponsiveComparisonTable';
